import React from 'react';
import Link from '../../Link';
import url from 'url';
import NestedTopNavMenuItem from './TopNavMenuItem';
import InlineSvg from '../../InlineSvg';

const TopNavMenuItem = (props) => {
  const { item, topLevel = false } = props;

  if (item?.childItems?.length) {
    return (
      <div
        className={`top-nav-menu-item ${
          topLevel
            ? 'top-nav-menu-item--top-level'
            : 'top-nav-menu-item--sub-menu'
        }`}
        role="listbox"
        tabIndex="0"
      >
        <div className="top-nav-menu-item__label">
          <span
            dangerouslySetInnerHTML={{
              __html: item.label,
            }}
          />
          <InlineSvg
            name={topLevel ? 'chevron-down-alt' : 'chevron-right'}
            color={topLevel && true ? 'brand-secondary' : 'brand-secondary'}
          />
        </div>
        <ul className="top-nav-menu-item__dropdown-menu">
          {item?.menuAcf?.menuIcon?.sourceUrl && (
            <li>
              <img
                className="top-nav-menu-item__icon"
                alt={item.label}
                src={item.menuAcf.menuIcon.sourceUrl}
              />
            </li>
          )}
          <li>
            <Link
              to={url.parse(item.url).pathname}
              className="top-nav-menu-item__dropdown-label"
            >
              <span dangerouslySetInnerHTML={{ __html: item.label }} />
            </Link>
          </li>
          {item.childItems.map((childItem, index) => (
            <NestedTopNavMenuItem
              item={childItem}
              topLevel={false}
              key={index}
            />
          ))}
        </ul>
      </div>
    );
  }

  return (
    <li
      className={`top-nav-menu-link ${
        topLevel ? 'top-nav-menu-link--top-level' : ''
      }`}
    >
      <Link tabIndex="0" to={url.parse(item.url).pathname}>
        {item.label}
      </Link>
    </li>
  );
};

export default TopNavMenuItem;
